/**
 * Presentational: page header with back button and title.
 * Single Responsibility: render header only (no business logic).
 */

import React from 'react';
import PropTypes from 'prop-types';
import { BackButton } from '../../../components/organizationWizard/BackButton';
import { PAGE_COPY } from '../constants';

const TITLE_CLASS =
  'font-[\'Roboto:SemiBold\',sans-serif] font-semibold text-[24px] sm:text-[26px] text-[#1a1a1a] leading-tight';

export function PageHeader({ title = PAGE_COPY.TITLE }) {
  return (
    <div className="mb-6">
      <div className="mb-4">
        <BackButton />
      </div>
      <h1 className={TITLE_CLASS}>{title}</h1>
    </div>
  );
}

PageHeader.propTypes = {
  title: PropTypes.string,
};
